module.exports = __webpack_public_path__ + "media/images/menu/canes_venatici-383625ad68b8af2df69831328700d88d.jpg";